/* @generated from adl */
import { declResolver, ScopedDecl } from "./runtime/adl";
import { _AST_MAP as AppCommands } from "./AppCommands";
import { _AST_MAP as AppEvents } from "./AppEvents";
import { _AST_MAP as Buffer } from "./Buffer";
import { _AST_MAP as ClientState } from "./ClientState";
import { _AST_MAP as CodeDiagnostics } from "./CodeDiagnostics";
import { _AST_MAP as FileTreeView } from "./FileTreeView";
import { _AST_MAP as HexgripError } from "./HexgripError";
import { _AST_MAP as InfoRequest } from "./InfoRequest";
import { _AST_MAP as LanguageEngine } from "./LanguageEngine";
import { _AST_MAP as Path } from "./Path";
import { _AST_MAP as PluginInterface } from "./PluginInterface";
import { _AST_MAP as PluginTypes } from "./PluginTypes";
import { _AST_MAP as SrcLoc } from "./SrcLoc";
import { _AST_MAP as SyntaxHighlighting } from "./SyntaxHighlighting";
import { _AST_MAP as Terminal } from "./Terminal";

export const ADL: { [key: string]: ScopedDecl } = {
  ...AppCommands,
  ...AppEvents,
  ...Buffer,
  ...ClientState,
  ...CodeDiagnostics,
  ...FileTreeView,
  ...HexgripError,
  ...InfoRequest,
  ...LanguageEngine,
  ...Path,
  ...PluginInterface,
  ...PluginTypes,
  ...SrcLoc,
  ...SyntaxHighlighting,
  ...Terminal,
};

export const RESOLVER = declResolver(ADL);
